import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { importProvidersFrom, LOCALE_ID } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { routes } from './app/app.routing';
import { provideRouter } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { TokenInterceptor } from './app/core/interceptors/token.interceptor';
import { HttpErrorInterceptor } from './app/core/interceptors/http-error.interceptor';
import { SpinnerInterceptor } from './app/core/interceptors/spinner.interceptor';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ToastrModule } from 'ngx-toastr';
import { AppConfig } from './app/core/config/app.config';
import { registerLocaleData } from '@angular/common';
import localeEsVe from '@angular/common/locales/es-VE';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

// Registrar localización de Venezuela para pipes como number/currency/percent
registerLocaleData(localeEsVe);

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'es-VE',
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true,
    },
    importProvidersFrom(
      BrowserAnimationsModule,
      ToastrModule.forRoot(AppConfig.TOAST_CONFIG),
      NgxDaterangepickerMd.forRoot()
    ),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: LOCALE_ID,
      useValue: 'es-VE',
    },
  ],
}).then(() => {
  const originalDateTimeFormat = Intl.DateTimeFormat;

  Intl.DateTimeFormat = function (locales?: string | string[], options?: Intl.DateTimeFormatOptions) {
    if (!options) options = {};
    options.timeZone = 'America/Caracas'; // 🔹 Forzar zona horaria a Caracas
    return new originalDateTimeFormat(locales, options);
  } as any;
  
})
.catch((error) => {
  console.error(error);
});

